import React from "react";

type PriceFormattedProps = {
    amount?: string;
    currency?: string;
};
export const PriceFormatted: React.FC<PriceFormattedProps> = ({amount, currency}: PriceFormattedProps) => {
    return (
        <span>{`${currency} ${amount}`}</span>
    );
}
